import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

export const FormaPagoService = {
	Listar: () => {
		let params = {};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Forma_Pago_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			id_cat_forma_pago: null,
			forma_pago: form.forma_pago,
			abreviacion: form.abreviacion,
			descripcion: form.descripcion,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Forma_Pago_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_cat_forma_pago: form.id_cat_forma_pago,
			forma_pago: form.forma_pago,
			abreviacion: form.abreviacion,
			descripcion: form.descripcion,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Forma_Pago_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_cat_forma_pago) => {
		let params = {
			id_cat_forma_pago: id_cat_forma_pago
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Forma_Pago_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
